
import { defineComponent } from 'vue'
import Player from '../components/Player.vue'

export default defineComponent({
    name: 'ProPage',
    components: {
        Player,
    },
    beforeCreate() {
        const password = prompt('Please enter the password to continue')
        if (password !== 'TAUR2021') {
            return this.$router.push('/')
        }
    }
})
